export const isAssetNameMessage = (value: string) =>
  value.length < 16 && value.split(/\s+/).length < 3;
